module.exports = "/assets/career/team/marcin.png?+eSmTuW";